import { buildColumnExpression } from "helpers/utils/build-column-expression";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    ALTERNATIVE_KEY_COLUMN_FIELD,
    KEY_COLUMN_FIELD,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/constants";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";

export class UseAlternativeIdRule extends Validator<IAttributeData[], IAttributeDataError> {
    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let hasDefaultKeyColumn = false;
        let hasAlternativeKeyColumn = false;

        if (!errors[RuleType.UseAlternativeId]) {
            const headers = Object.keys(model[0] || {});
            hasDefaultKeyColumn = !!headers.find((header) => {
                const expression = buildColumnExpression(header);
                return expression.test(KEY_COLUMN_FIELD);
            });
            hasAlternativeKeyColumn = !!headers.find((header) => {
                const expression = buildColumnExpression(header);
                return expression.test(ALTERNATIVE_KEY_COLUMN_FIELD);
            });
        }

        const validationErrors =
            // If user includes both Code/ID and ID in the file
            hasDefaultKeyColumn && hasAlternativeKeyColumn
                ? {
                      ...errors,
                      [RuleType.UseAlternativeId]: formatMessage(
                          'We found an extra "ID" column in your file. Please remove or rename it and try your upload again. (This cannot be used as an attribute name.)'
                      ),
                  }
                : errors;

        return super.validate(model, validationErrors);
    }
}
